import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BaseResourceEffects } from '../base-resource.effects';
import { scheduledMeetingActions } from './scheduled-meeting.actions';
import { ScheduledMeetingService } from '../../services/scheduled-meeting.service';
import { CoreAppState } from '../core-app.state';
import { Injectable } from '@angular/core';
import { selectScheduledMeetingState } from './scheduled-meeting.reducer';
import { Store } from '@ngrx/store';
import { ScheduledMeetingResourceTypeMappings } from '@aa/nest/resource';
import { mergeMap, take, switchMap, map, catchError, of } from 'rxjs';

@Injectable()
export class ScheduledMeetingEffects extends BaseResourceEffects<ScheduledMeetingResourceTypeMappings> {
  approve$ = createEffect(() =>
    this.actions$.pipe(
      ofType(scheduledMeetingActions.approve),
      mergeMap((payload) =>
        this.store
          .select((s) => this.stateSelector(s).currentQuery)
          .pipe(
            take(1),
            switchMap((currentQuery) =>
              this.service.approveMeeting(payload.id).pipe(
                map((res) =>
                  this.itemActions.loadItems({
                    query: currentQuery as any,
                  }),
                ),
                catchError((err) =>
                  of(
                    this.itemActions.setError({
                      error:
                        err.error?.message?.toString() ??
                        err.message?.toString() ??
                        err.toString(),
                    }),
                  ),
                ),
              ),
            ),
          ),
      ),
    ),
  );

  reject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(scheduledMeetingActions.reject),
      mergeMap((payload) =>
        this.store
          .select((s) => this.stateSelector(s).currentQuery)
          .pipe(
            take(1),
            switchMap((currentQuery) =>
              this.service.rejectMeeting(payload.id).pipe(
                map((res) =>
                  this.itemActions.loadItems({
                    query: currentQuery as any,
                  }),
                ),
                catchError((err) =>
                  of(
                    this.itemActions.setError({
                      error:
                        err.error?.message?.toString() ??
                        err.message?.toString() ??
                        err.toString(),
                    }),
                  ),
                ),
              ),
            ),
          ),
      ),
    ),
  );

  cancel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(scheduledMeetingActions.cancel),
      mergeMap((payload) =>
        this.store
          .select((s) => this.stateSelector(s).currentQuery)
          .pipe(
            take(1),
            switchMap((currentQuery) =>
              this.service.cancelMeeting(payload.id).pipe(
                map((res) =>
                  this.itemActions.loadItems({
                    query: currentQuery as any,
                  }),
                ),
                catchError((err) =>
                  of(
                    this.itemActions.setError({
                      error:
                        err.error?.message?.toString() ??
                        err.message?.toString() ??
                        err.toString(),
                    }),
                  ),
                ),
              ),
            ),
          ),
      ),
    ),
  );

  constructor(
    protected override readonly actions$: Actions,
    protected override readonly store: Store<CoreAppState>,
    protected override readonly service: ScheduledMeetingService,
  ) {
    super(
      actions$,
      store,
      service,
      scheduledMeetingActions,
      selectScheduledMeetingState,
    );
  }
}
